import { success, failure, request } from 'app/actions';
import * as actions from './profilesActions';

const initialState = {
  teachers: [],
  isLoading: false,
  hasError: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.CHANGE_TEACHER_EDIT):
      return {
        ...state,
        isLoading: true,
      };
    case request(actions.GET_TEACHERS):
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case success(actions.GET_TEACHERS):
      return {
        ...state,
        isLoading: false,
        teachers: action.payload.content,
      };
    case failure(actions.GET_TEACHERS):
      return {
        ...state,
        isLoading: false,
        teachers: [],
      };
    default:
      return state;
  }
};

export default reducer;
